import { Headers } from 'src/components/shared/ui/table/types';

export const skillsHeadersEmp: Headers[] = [
  { header: 'Skill', key: 'name' },
  { header: 'Estado', key: 'isValidated' },
  { header: 'Acciones', key: 'actions' },
];
